import { Howl } from 'howler'
import { useState } from 'react'

interface UsePlayAudioProps {
  file: string
  onLoaded?: (sound: Howl) => void
}
export function usePlayAudio(props: UsePlayAudioProps) {
  const { file, onLoaded } = props
  const [playing, setPlaying] = useState(false)
  const [sound, setSound] = useState<Howl | null>(null)
  const [duration, setDuration] = useState(0)
  const [seek, setSeek] = useState(0)

  useEffect(() => {
    if (!file) {
      return
    }
    const audio = new Howl({
      src: [file],
      onload: () => {
        setDuration(audio.duration())
        onLoaded?.(audio)
      },
      onplay: () => setPlaying(true),
      onstop: () => setPlaying(false),
      onend: () => setPlaying(false),
      onpause: () => setPlaying(false),
      loop: false,
      html5: true,
    })

    setSound(audio)

    // 清理音频实例
    return () => {
      audio.stop()
      audio.unload()
    }
  }, [file])

  useEffect(() => {
    let timer: number
    if (sound && playing) {
      timer = window.setInterval(() => {
        setSeek(sound?.seek() || 0)
      }, 100)
    }
    return () => {
      if (timer) {
        clearInterval(timer)
      }
    }
  }, [sound, playing])

  const handlePlay = () => {
    if (sound) {
      if (playing) {
        sound.pause()
      } else {
        sound.play()
      }
    }
  }

  return { playing, sound, handlePlay, duration, seek, setSeek }
}
